import currencySymbolMapping from './utils/currencySymbolMapping';

const isValidCurrencySymbol = (code: string): code is keyof typeof currencySymbolMapping =>
  code in currencySymbolMapping;

export default isValidCurrencySymbol;
